/* eslint-disable-next-line no-undef */
const baseUrl = typeof SITENAME !== 'undefined' ? SITENAME : '';

export default {
  install(Vue) {
    Vue.prototype.SbBaseUrl = baseUrl;
  },
  baseUrl,
};
